import React from 'react';
import { Snackbar } from '@material-ui/core';
import RepliconSlide from '~/modules/common/components/RepliconSlide';
import { useSnackbar } from './SnackbarContext';

const SnackbarContainer: React.FC = () => {
  const { snackbar, dismissSnackbar } = useSnackbar();

  if (!snackbar) {
    return null;
  }

  const {
    message,
    options: { autoHideDuration, anchorOrigin }
  } = snackbar;

  return (
    <Snackbar
      key={snackbar.id}
      open={Boolean(snackbar)}
      autoHideDuration={autoHideDuration}
      onClose={dismissSnackbar}
      TransitionComponent={RepliconSlide as any}
      anchorOrigin={anchorOrigin}
      message={message}
    />
  );
};

export default SnackbarContainer;
